const prefix = `editable-selector`;

export const dataHooks = {
  row: `${prefix}-row`,
  item: `${prefix}-item`,
  title: `${prefix}-title`,
  deleteItem: 'delete-item',
  editItem: 'edit-item',
  newRowButtonText: 'new-row-button-text',
  editRowWrapper: 'edit-row-wrapper',
};

export const TOGGLE_TYPE = {
  checkbox: 'checkbox',
  radio: 'radio',
};
